/**
 * @description Enum for status when interacting with the database
 */
enum Status {
    
    /**
     * @description No status
     */
    NEURAL = "NEURAL",

    /**
     * @description Status when the data is loading
     */
    LOADING = "LOADING",

    /**
     * @description Status when the data is loaded successfully
     */
    LOAD_SUCCESS = "LOAD_SUCCESS",

    /**
     * @description Status when the data was not loaded successfully
     */
    LOAD_ERROR = "LOAD_ERROR",

    /**
     * @description Status when the data is saving
     */
    SAVING = "SAVING",

    /**
     * @description Status when the data is saved successfully
     */
    SAVE_SUCCESS = "SAVE_SUCCESS",

    /**
     * @description Status when the data was not saved successfully
     */
    SAVE_ERROR = "SAVE_ERROR",

    /**
     * @description Status when the data is deleting
     */
    DELETING = "DELETING",

    /**
     * @description Status when the data is deleted successfully
     */
    DELETE_SUCCESS = "DELETE_SUCCESS",

    /**
     * @description Status when the data was not deleted successfully
     */
    DELETE_ERROR = "DELETE_ERROR"
}

export default Status;